import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import index from "@beeldit/core/services";
import { FiltersContext } from "../filters/FiltersContext";
import { BillingGraphContext } from "./BillingGraphContext";

function useBillingIndex() {
  const { setGraphData } = useContext(BillingGraphContext);
  const { tableFilters } = useContext(FiltersContext);
  const errorHandler = useErrorHandler();
  return () => {
    let filterPath = "measure=billing";
    if (tableFilters) {
      for (const [key, value] of Object.entries(tableFilters)) {
        if (value) {
          filterPath += `&${key}=${value}`;
        }
      }
    }
    index("graph", filterPath)
      .then((response: any) => {
        setGraphData(response.data);
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useBillingIndex;
